import React, {Component} from 'react';
import Header from "../header";
import Footer from "../footer";
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import DashboardDetail from "./dashboard-detail";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

export default class Orders extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            submitMessage: "",
            orders: [],
            selected: [],
            selectedDate: [],
            fulldate: null,
            isInputChecked: false,
            ordersdate: [],

            panoramicAlbumArr: [],
            schoolAlbumArr: [],
            tualAlbumArr: [],
            photoBlockArr: [],
            printingArr: [],
        }
    }

    componentDidMount() {
        let panoramik = [
            "Sıra Numarası",
            "Albüm Ebatı",
            "Albüm Sayısı",
            "Aile Albümü (Adet)",
            "Aile Albümü Ebat",
            "Cep Albümü (Adet)",
            "Cep Albümü Ebat",
            "Albüm Türü",
            "Sayfa Sayısı",
            "Kapak Modeli",
            "Albüm Sıralaması",
            "Baskı (Ebat)",
            "Tual (Ebat)",
            "Açıklama",
            "Müşteri Mail Adresi",
            "Sipariş Numarası",
            "Firma Adı",
            "Baskı2 (Ebat)",
            "Baskı3 (Ebat)",
            "Tual2 (Ebat)",
            "Tual3 (Ebat)",
            "Gelin & Damat & Bebek İsim",
            "Gelin & Damat & Bebek Tarih"
        ];

        let school = [
            "Sıra Numarası",
            "Albüm Ebatı",
            "Sayfa Sayısı",
            "Öğrenci Sayısı",
            "Takvim Ebatı",
            "Takvim Sayısı",
            "Açıklama",
            "Firma Mail Adresi",
            "Firma İsmi",
            "Sipariş Numarası",
        ];

        let tual = [
            "Sıra Numarası",
            "Tual Ebatı",
            "Tual Sayısı",
            "Açıklama",
            "Firma Mail Adresi",
            "Sipariş Numarası",
            "Firma İsmi",
        ];

        let photoBlock = [
            "Sıra Numarası",
            "Fotoblok Ebatı",
            "Fotoblok Sayısı",
            "Açıklama",
            "Firma Mail Adresi",
            "Sipariş Numarası",
            "Firma Maili",
        ];

        let printing = [
            "Sıra Numarası",
            "Baskı Ebatı",
            "Baskı Sayısı",
            "Açıklama",
            "Firma Mail Adresi",
            "Sipariş Numarası",
            "Firma Maili",
        ];

        this.setState({
            panoramicAlbumArr: panoramik,
            schoolAlbumArr: school,
            tualAlbumArr: tual,
            photoBlockArr: photoBlock,
            printingArr: printing,
        })
    }

    getOrders(){
        fetch("https://saydamalbum.com/saydamWebservice/getUserOrders.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "isDate=" + "false"
            + "&companyMail=" + localStorage.getItem("companyMail")
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);
            this.setState({
                orders: data.data,
            })
        });


    }

    getOrdersDate() {
        fetch("https://saydamalbum.com/saydamWebservice/getUserOrders.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body:  "isDate=" + "true"
            + "&date=" + this.state.fulldate
            + "&companyMail=" + localStorage.getItem("companyMail")
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);
            if (data.responseType === 200) {
                this.setState({
                    ordersdate: data.data,
                    ordersdateError: false,
                });
            } else {
                this.setState({
                    ordersdateError: true
                })
            }
        });
    }

    datePickerChange(param1, date) {
        let fulldate = date.getFullYear() + "-" + parseInt(date.getMonth() + 1, 10) + "-" + date.getDate();

        this.setState({
            datePickerValue: date,
            fulldate: fulldate,
        });
        console.log(fulldate);
    }


    isSelected = (index) => {
        return this.state.selected.indexOf(index) !== -1;
    };

    isSelectedDate = (index) => {
        return this.state.selectedDate.indexOf(index) !== -1;
    };


    handleRowSelection = (selectedRows) => {
        if (!(selectedRows.length === 0)) {
            let selectedName = this.state.orders[selectedRows].o_orderName;
            let selectedID = this.state.orders[selectedRows].o_orderID;

            this.setState({
                ordersName: this.state.orders[selectedRows].o_orderName,
                selected: selectedRows,
            });

            fetch("https://saydamalbum.com/saydamWebservice/getOrderDetail.php", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: "orderID=" + selectedID
                + "&orderName=" + selectedName
            }).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data);

                if (data.responseType === 200) {
                    this.setState({
                        orderDetailsArr: data.data,
                        orderDetailsReady: true,
                    })
                }
            });
        }
    };

    handleRowSelectionDate = (selectedRows) => {
        if (selectedRows.length === 0) {

        } else {
            let selectedID = this.state.ordersdate[selectedRows].o_orderID;
            let selectedName = this.state.ordersdate[selectedRows].o_orderName;

            this.setState({
                ordersName: this.state.ordersdate[selectedRows].o_orderName,
                selectedDate: selectedRows,
            });

            fetch("https://saydamalbum.com/saydamWebservice/getOrderDetail.php", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: "orderID=" + selectedID
                + "&orderName=" + selectedName
            }).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data);

                if (data.responseType === 200) {
                    this.setState({
                        orderDetailsArr: data.data,
                        orderDetailsReady: true,
                    })
                }
                console.log(selectedRows);
            });
        }

    };

    popupClose() {
        this.setState({
            orderDetailsReady: false,
        })
    }

    render() {

        const row = (item, key) =>
            <TableRow key={key} selected={this.isSelected(key)}>
                <TableRowColumn title={item.o_orderID}> #{item.o_orderID} {item.p_brideName ? `--> ${item.p_brideName}` : ''}</TableRowColumn>
                <TableRowColumn title={item.o_orderDate}> {item.o_orderDate}</TableRowColumn>
                <TableRowColumn title={item.o_orderName}> {item.o_orderName}</TableRowColumn>
                <TableRowColumn title={item.o_companyName}> {item.o_companyName}</TableRowColumn>
                <TableRowColumn title={item.o_companyMail}> {item.o_companyMail}</TableRowColumn>
                <TableRowColumn title={item.o_orderStatus}> {item.o_orderStatus}</TableRowColumn>
            </TableRow>;

        const rowsdate = (item, key) =>
            <TableRow key={key} selected={this.isSelectedDate(key)}>
                <TableRowColumn title={item.o_orderID}> #{item.o_orderID} {item.p_brideName ? `--> ${item.p_brideName}` : ''}</TableRowColumn>
                <TableRowColumn title={item.o_orderDate}> {item.o_orderDate}</TableRowColumn>
                <TableRowColumn title={item.o_orderName}>{ item.o_orderName}</TableRowColumn>
                <TableRowColumn title={item.o_companyName}> {item.o_companyName}</TableRowColumn>
                <TableRowColumn title={item.o_companyMail}> {item.o_companyMail}</TableRowColumn>
                <TableRowColumn title={item.o_orderStatus}> {item.o_orderStatus}</TableRowColumn>
            </TableRow>;

        return (
            <div>
                <Header/>

                <main className="orders">
                    <div className="container">
                        <div className="orders-container">
                            <div className="orders-top">

                                <div className="toggled">
                                    <Toggle
                                        label="Sipariş Tarihini Belirle"
                                        onToggle={(e, inputChecked) => this.setState({isInputChecked: inputChecked})}
                                    />
                                </div>

                                <form className="input-group">
                                    {!this.state.isInputChecked ? (
                                        <div>
                                            <RaisedButton
                                                label="Son Siparişleri Getir"
                                                primary={true}
                                                type="button"
                                                onClick={this.getOrders.bind(this)}
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <DatePicker
                                                hintText="Tarihi Giriniz.."
                                                firstDayOfWeek={0}
                                                locale='tr-TR'
                                                okLabel="Tamam"
                                                cancelLabel="İptal"
                                                autoOk="true"
                                                onChange={this.datePickerChange.bind(this)}
                                                DateTimeFormat={ Intl.DateTimeFormat}
                                            />

                                            <RaisedButton
                                                label="Siparişleri Getir"
                                                primary={true}
                                                type="button"
                                                onClick={this.getOrdersDate.bind(this)}
                                            />

                                        </div>
                                    )}
                                </form>
                            </div>

                            <div className="orders-bottom">
                                {!this.state.isInputChecked ? (
                                    <Table onRowSelection={this.handleRowSelection}>
                                        <TableHeader adjustForCheckbox={false} displaySelectAll={false}
                                                     fixedHeader={true}>
                                            <TableRow>
                                                <TableHeaderColumn> Sipariş Numarası </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Tarihi </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Türü </TableHeaderColumn>
                                                <TableHeaderColumn> Firma İsmi </TableHeaderColumn>
                                                <TableHeaderColumn> Firma Mail </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Durumu </TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody
                                            deselectOnClickaway={false}
                                            displayRowCheckbox={false}
                                            rowNumber={true}
                                        >
                                            {this.state.orders.map((item, key) => row(item, key))}
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <Table onRowSelection={this.handleRowSelectionDate}>
                                        <TableHeader adjustForCheckbox={false} displaySelectAll={false}
                                                     fixedHeader={true}>
                                            <TableRow>
                                                <TableHeaderColumn> Sipariş Numarası </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Tarihi </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Türü </TableHeaderColumn>
                                                <TableHeaderColumn> Firma İsmi </TableHeaderColumn>
                                                <TableHeaderColumn> Firma Mail </TableHeaderColumn>
                                                <TableHeaderColumn> Sipariş Durumu </TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody
                                            deselectOnClickaway={false}
                                            displayRowCheckbox={false}
                                            rowNumber={true}
                                        >
                                            {(this.state.ordersdateError && this.state.ordersdate.length > 0) ? (
                                                <p className="error">
                                                    Ne yazık ki belirttiğiniz tarihte sipariş görünmüyor.
                                                </p>
                                            ) : (
                                                this.state.ordersdate.map((item, key) => rowsdate(item, key))
                                            )}
                                        </TableBody>
                                    </Table>
                                )}
                            </div>

                            {(this.state.orderDetailsReady) ? (
                                <div className="custom-table-popup">
                                    <div className="popup-background"></div>
                                    <div className="popup-content">
                                        <div className="popup-title">
                                            <h3> Sipariş Detayları </h3>
                                            <i className="material-icons" onClick={this.popupClose.bind(this)}>
                                                close </i>
                                        </div>
                                        <div className="popup-list">
                                            <ul id="popupPrint">
                                                { Object.keys(this.state.orderDetailsArr).map((item, i) => (
                                                    <DashboardDetail
                                                        el={item}
                                                        orders={this.state.orderDetailsArr}
                                                        ordersName={this.state.ordersName}
                                                        panoramic={this.state.panoramicAlbumArr}
                                                        school={this.state.schoolAlbumArr}
                                                        tual={this.state.tualAlbumArr}
                                                        photoblock={this.state.photoBlockArr}
                                                        printing={this.state.printingArr}
                                                        key={i}
                                                        orderKey={i}
                                                    />
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <span></span>
                            )}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        );
    }


}


// WEBPACK FOOTER //
// ./src/components/orders.js